import * as React from "react";
import { BreadCrumbs } from "./Breadcrumbs";
import { Container, Layout, styled, } from "@volkswagen-onehub/components-core";
import { breakpoints } from "@volkswagen-onehub/tokens";
const MarginContainer = styled.div `
  margin-bottom: 40px;
`;
export function View(props) {
    const { path, children } = props;
    return (React.createElement(Layout, { allowOverflowingContent: true, appearance: {
            [breakpoints.default]: [
                {
                    name: ".",
                    columns: 2,
                },
                {
                    name: "a",
                    columns: 20,
                },
                {
                    name: ".",
                    columns: 2,
                },
                {
                    name: ".",
                    columns: 1,
                },
                {
                    name: "b",
                    columns: 22,
                },
                {
                    name: ".",
                    columns: 1,
                },
            ],
        } },
        React.createElement(Container, { wrap: "always" },
            React.createElement(MarginContainer, null,
                React.createElement(BreadCrumbs, { path: path }))),
        children));
}
